import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
  KanbanConfig,
  KanbanDepartamento,
  KanbanDepartamentoSeller,
  KanbanEtapa,
  KanbanFormularioCampo,
  KanbanFormularioCampoOpcao,
  KanbanFormularioTipo,
  KanbanSeller
} from '../../core/models/kanban/kanban';
import { KanbanService } from '../../core/services/kanban/kanban.service';

@Component({
  standalone: false,
  selector: 'app-kanban-config',
  templateUrl: './kanban-config.component.html',
  styleUrls: ['./kanban-config.component.css']
})
export class KanbanConfigComponent implements OnInit {
  permitido: boolean = false;
  carregando: boolean = false;

  departamentos: KanbanDepartamento[] = [];
  etapas: KanbanEtapa[] = [];
  sellers: KanbanSeller[] = [];
  vinculos: KanbanDepartamentoSeller[] = [];
  vinculosVisiveis: KanbanDepartamentoSeller[] = [];
  formularios: KanbanFormularioTipo[] = [];
  formularioCampos: KanbanFormularioCampo[] = [];
  formularioOpcoes: KanbanFormularioCampoOpcao[] = [];

  departamentoSelecionadoId: number = 0;
  departamentoEditando: KanbanDepartamento = null;
  formularioSelecionadoId: number = 0;
  formularioEditando: KanbanFormularioTipo = null;

  novoDepartamento: any = this.criarDepartamento();
  novaEtapa: any = this.criarEtapa();
  novoFormulario: any = this.criarFormulario();
  novoCampo: any = this.criarCampo();
  novaOpcaoPorCampo: any = {};

  tiposEtapa: string[] = ['ABERTO', 'PIPELINE', 'GANHO', 'PERDA'];
  tiposCampo: string[] = ['CADASTRO', 'DATA', 'EMAIL', 'DECIMAL', 'INTEIRO', 'TELEFONE', 'TEXTO', 'PRODUTO', 'ARQUIVO', 'ALTERNATIVA'];

  constructor(
    private kanbanService: KanbanService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.permitido = true;
    this.carregar();
  }

  carregar() {
    this.carregando = true;

    this.kanbanService.getConfig().subscribe(
      (config: KanbanConfig) => {
        this.aplicarConfig(config);
      },
      () => {
        this.carregando = false;
      },
      () => {
        this.carregando = false;
      }
    );
  }

  aplicarConfig(config: KanbanConfig) {
    this.permitido = config != null && config.permitido;

    if (!this.permitido) {
      return;
    }

    this.departamentos = config.departamentos || [];
    this.etapas = config.etapas || [];
    this.sellers = config.sellers || [];
    this.vinculos = config.departamento_sellers || [];
    this.formularios = config.formularios || [];
    this.formularioCampos = config.formulario_campos || [];
    this.formularioOpcoes = config.formulario_opcoes || [];
    this.formularioCampos.forEach(campo => {
      if (!this.novaOpcaoPorCampo[campo.id]) {
        this.novaOpcaoPorCampo[campo.id] = { nome: '', valor: '', ordem: 10, ativo: true };
      }
    });

    if (!this.departamentoSelecionadoId && this.departamentos.length > 0) {
      this.departamentoSelecionadoId = this.departamentos[0].id;
    }

    this.atualizarDepartamentoEditando();
    this.atualizarFormularioSelecionado();
    this.atualizarVinculosVisiveis();
    this.novaEtapa.departamento_id = this.departamentoSelecionadoId;
    this.novoFormulario.departamento_id = this.departamentoSelecionadoId;
  }

  selecionarDepartamento(id: number) {
    this.departamentoSelecionadoId = Number(id);
    this.novaEtapa = this.criarEtapa();
    this.novoFormulario = this.criarFormulario();
    this.formularioSelecionadoId = 0;
    this.atualizarDepartamentoEditando();
    this.atualizarFormularioSelecionado();
    this.atualizarVinculosVisiveis();
  }

  etapasDoDepartamento(): KanbanEtapa[] {
    return this.etapas.filter(e => e.departamento_id === this.departamentoSelecionadoId);
  }

  formulariosDoDepartamento(): KanbanFormularioTipo[] {
    return this.formularios.filter(f => f.departamento_id === this.departamentoSelecionadoId);
  }

  camposDoFormulario(): KanbanFormularioCampo[] {
    return this.formularioCampos
      .filter(c => c.formulario_tipo_id === this.formularioSelecionadoId)
      .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  opcoesDoCampo(campoId: number): KanbanFormularioCampoOpcao[] {
    return this.formularioOpcoes
      .filter(o => o.campo_id === campoId)
      .sort((a, b) => (a.ordem || 0) - (b.ordem || 0));
  }

  salvarDepartamento(departamento: any, novo: boolean) {
    if (!departamento.nome || departamento.nome.trim() === '') {
      this.toastr.warning('', 'Informe o nome do departamento.');
      return;
    }

    this.kanbanService.saveDepartment(departamento).subscribe(id => {
      if (id > 0) {
        this.toastr.success('', 'Departamento salvo.');

        if (novo) {
          this.novoDepartamento = this.criarDepartamento();
        }

        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar o departamento.');
      }
    });
  }

  salvarEtapa(etapa: any, nova: boolean) {
    if (!etapa.nome || etapa.nome.trim() === '') {
      this.toastr.warning('', 'Informe o nome da etapa.');
      return;
    }

    etapa.departamento_id = this.departamentoSelecionadoId;

    this.kanbanService.saveStage(etapa).subscribe(id => {
      if (id > 0) {
        this.toastr.success('', 'Etapa salva.');

        if (nova) {
          this.novaEtapa = this.criarEtapa();
        }

        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar a etapa.');
      }
    });
  }

  atualizarVinculosVisiveis() {
    this.vinculosVisiveis = [];

    this.sellers.forEach(seller => {
      var existente = this.vinculos.find(v => v.departamento_id === this.departamentoSelecionadoId && v.seller_id === seller.id);

      if (existente == null) {
        existente = {
          departamento_id: this.departamentoSelecionadoId,
          seller_id: seller.id,
          seller_nome: seller.fullname,
          pode_criar: true,
          pode_editar: true,
          pode_mover: true,
          ativo: false
        };

        this.vinculos.push(existente);
      }

      this.vinculosVisiveis.push(existente);
    });
  }

  salvarVinculo(vinculo: KanbanDepartamentoSeller) {
    this.kanbanService.saveDepartmentSeller(vinculo).subscribe(salvo => {
      if (salvo) {
        this.toastr.success('', 'Vinculo salvo.');
        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar o vinculo.');
      }
    });
  }

  selecionarFormulario(id: number) {
    this.formularioSelecionadoId = Number(id);
    this.atualizarFormularioEditando();
    this.novoCampo = this.criarCampo();
  }

  salvarFormulario(formulario: any, novo: boolean) {
    if (!formulario.nome || formulario.nome.trim() === '') {
      this.toastr.warning('', 'Informe o nome do formulario.');
      return;
    }

    formulario.departamento_id = this.departamentoSelecionadoId;

    this.kanbanService.saveFormType(formulario).subscribe(id => {
      if (id > 0) {
        this.toastr.success('', 'Formulario salvo.');

        if (novo) {
          this.formularioSelecionadoId = id;
          this.novoFormulario = this.criarFormulario();
        }

        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar o formulario.');
      }
    });
  }

  salvarCampo(campo: any, novo: boolean) {
    if (!campo.nome || campo.nome.trim() === '') {
      this.toastr.warning('', 'Informe o nome do campo.');
      return;
    }

    campo.formulario_tipo_id = this.formularioSelecionadoId;
    campo.chave = campo.chave || this.gerarChaveCampo(campo.nome);

    this.kanbanService.saveFormField(campo).subscribe(id => {
      if (id > 0) {
        this.toastr.success('', 'Campo salvo.');

        if (novo) {
          this.novoCampo = this.criarCampo();
        }

        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar o campo.');
      }
    });
  }

  salvarOpcao(campo: KanbanFormularioCampo) {
    const opcao = this.novaOpcaoPorCampo[campo.id] || { nome: '', valor: '', ordem: 10, ativo: true };

    if (!opcao.nome || opcao.nome.trim() === '') {
      this.toastr.warning('', 'Informe o nome da opcao.');
      return;
    }

    opcao.campo_id = campo.id;
    opcao.valor = opcao.valor || opcao.nome;

    this.kanbanService.saveFormFieldOption(opcao).subscribe(id => {
      if (id > 0) {
        this.toastr.success('', 'Opcao salva.');
        this.novaOpcaoPorCampo[campo.id] = { nome: '', valor: '', ordem: 10, ativo: true };
        this.carregar();
      } else {
        this.toastr.error('', 'Nao foi possivel salvar a opcao.');
      }
    });
  }

  editarOpcao(opcao: KanbanFormularioCampoOpcao) {
    this.kanbanService.saveFormFieldOption(opcao).subscribe(id => {
      if (id > 0) {
        this.toastr.success('', 'Opcao salva.');
        this.carregar();
      }
    });
  }

  campoPadrao(chave: string): boolean {
    return ['nome_negocio', 'client_id', 'data_fechamento_prevista', 'seller_id_responsavel'].indexOf(chave) >= 0;
  }

  private criarDepartamento(): any {
    return {
      id: 0,
      nome: '',
      descricao: '',
      ordem: 1,
      ativo: true
    };
  }

  private criarEtapa(): any {
    return {
      id: 0,
      departamento_id: this.departamentoSelecionadoId,
      nome: '',
      tipo: 'PIPELINE',
      ordem: 10,
      ativo: true
    };
  }

  private criarFormulario(): any {
    return {
      id: 0,
      departamento_id: this.departamentoSelecionadoId,
      nome: '',
      descricao: '',
      ordem: 10,
      ativo: true
    };
  }

  private criarCampo(): any {
    return {
      id: 0,
      formulario_tipo_id: this.formularioSelecionadoId,
      nome: '',
      chave: '',
      tipo: 'TEXTO',
      obrigatorio: false,
      permite_multiplos: false,
      ordem: 10,
      placeholder: '',
      texto_ajuda: '',
      valor_padrao: '',
      ativo: true
    };
  }

  private atualizarDepartamentoEditando() {
    this.departamentoEditando = this.departamentos.find(d => d.id === this.departamentoSelecionadoId);
  }

  private atualizarFormularioSelecionado() {
    const formularios = this.formulariosDoDepartamento();

    if (!this.formularioSelecionadoId && formularios.length > 0) {
      this.formularioSelecionadoId = formularios[0].id;
    }

    if (this.formularioSelecionadoId && !formularios.some(f => f.id === this.formularioSelecionadoId)) {
      this.formularioSelecionadoId = formularios.length > 0 ? formularios[0].id : 0;
    }

    this.atualizarFormularioEditando();
    this.novoCampo = this.criarCampo();
  }

  private atualizarFormularioEditando() {
    this.formularioEditando = this.formularios.find(f => f.id === this.formularioSelecionadoId);
  }

  private gerarChaveCampo(nome: string): string {
    return (nome || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }
}
